import React, { useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';

import {
  PARTNER_SUPPORT_AND_COLLABORATION_SECTION_LIST,
  HANDS_ON_SUPPORT_AND_COLLABORATION,
  HOW_WE_CAN_WORK_TOGETHER_AND_IMPROVE,
} from '../../constants/Pages/PartnerWithUs';

import './PartnerSupportCollaborate.css';

export const PartnerSupportCollaborate = () => {
  const [expandedSections, setExpandedSections] = useState({});
  return (
    <div className="partner-support-collaborate-container">
      <div>
        <h2 className="partner-support-collaborate-header">{HANDS_ON_SUPPORT_AND_COLLABORATION}</h2>
        <h5 className="partner-support-collaborate-sub-header">
          {HOW_WE_CAN_WORK_TOGETHER_AND_IMPROVE}
        </h5>

        <div className="partner-portal-list">
          {PARTNER_SUPPORT_AND_COLLABORATION_SECTION_LIST.map((step) => (
            <Accordion
              sx={{
                '&:first-of-type': {
                  borderTopLeftRadius: '10px',
                  borderTopRightRadius: '10px',
                },
                '&:last-of-type': {
                  borderBottomLeftRadius: '10px',
                  borderBottomRightRadius: '10px',
                },
                '&.Mui-expanded': {
                  margin: '0 auto',
                },
                border: '1px solid black',
                p: '1.25rem',
                p: { xs: '.5rem', sm: '0.5rem' },
                width: { xs: '80%', sm: '50%' },
                margin: '0 auto',
                borderRadius: '10px',
              }}
              expanded={expandedSections[step.title]}
              onChange={() => {
                setExpandedSections((prevState) => {
                  const copyPrevState = { ...prevState };
                  if (prevState[step.title]) {
                    delete copyPrevState[step.title];

                    mixpanel.track('Hands-On Support and Collaboration', {
                      stepTitle: step.title,
                      action: 'Close',
                    });

                    return copyPrevState;
                  }

                  mixpanel.track('Hands-On Support and Collaboration', {
                    stepTitle: step.title,
                    action: 'Open',
                  });

                  return {
                    ...copyPrevState,
                    [step.title]: step.title,
                  };
                });
              }}
              key={step.title}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                className="partner-portal-section-header"
                sx={{
                  '&.Mui-expanded': {
                    minHeight: '50px',
                  },
                }}
              >
                {step.title}
              </AccordionSummary>

              <AccordionDetails
                sx={{
                  padding: '8px 16px',
                }}
              >
                <div className="partner-portal-section-sub-header">{step.subheader()}</div>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </div>
    </div>
  );
};
